import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { NewCustomTablePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import FormModal from 'modules/employees/components/CustomTables/FormModal'
import Loading from 'modules/employees/components/CustomTables/FormModal/Loading'
import MissingResource from 'modules/employees/components/CustomTables/FormModal/MissingResource'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

export default function NewCustomTablePage() {
  const navigate = useNavigate()

  const { id: employeeIdparam, schemaId } = useStrictParams<'id' | 'schemaId'>()
  const { employee: sessionEmployee } = useCurrentSession()

  const employeeId = employeeIdparam ? Number(employeeIdparam) : sessionEmployee.id

  const rootRoute = React.useContext(RouteContext)

  const { data, loading } = useQuery(NewCustomTablePageDocument, {
    variables: {
      employeeId: employeeId,
      schemaId: Number(schemaId),
    },
    skip: !schemaId,
  })

  const schema = data?.customResources.schema
  const currency = data?.employees.employee?.legalEntity?.currency ?? ''
  const canRemoveCustomTableRecords =
    data?.employees?._policies?.removeCustomTableRecords?.can ?? false

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  if (loading) {
    return <Loading />
  }

  if (!schema) return <MissingResource />

  return (
    <FormModal
      schema={schema}
      employeeId={employeeId}
      currency={currency}
      canRemoveCustomTableRecords={canRemoveCustomTableRecords}
      onClose={onClose}
    />
  )
}
